import { useEffect, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { useRecoilValue } from 'recoil';
import { Permission, permissionState } from 'state/permissionState';
import { GeneralIds, RoutePaths } from 'types/types';
import { getRoutePath } from 'utils';

export default function useHasAccessToPage() {
  const [hasAccess, setHasAccess] = useState(true);
  const permissions = useRecoilValue(permissionState);
  const ids = useParams<GeneralIds>();

  const location = useLocation();

  useEffect(() => {
    if (permissions.length !== 0) {
      const hasAccessToLocation = getHasAccessToLocation({
        location: location.pathname,
        permissions,
        ids,
      });
      setHasAccess(hasAccessToLocation);
    }
  }, [location, permissions, ids]);

  return { hasAccess };
}

function getHasAccessToLocation({
  location,
  permissions,
  ids,
}: {
  location: string;
  permissions: string[];
  ids: GeneralIds;
}) {
  switch (location) {
    case getRoutePath(RoutePaths.users, ids):
      return (
        permissions.includes(Permission.READ_ALL_USER) ||
        permissions.includes(Permission.SUPERADMIN)
      );
    default:
      return true;
  }
}
